import { Component, ErrorHandler, OnInit, ViewChild } from '@angular/core';
declare var $: any;
import { DataTableDirective } from 'angular-datatables';
import { UserService } from '../../../shared/user.service';
import swal from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { NgForm } from '@angular/forms';



@Component({
  selector: 'app-division-dept-grid',
  templateUrl: './division-dept-grid.component.html',
  styleUrls: ['./division-dept-grid.component.css']
})
export class DivisionDeptGridComponent implements OnInit {

  data : any = {};
  formInvalid : boolean = false;
  c : any = {};
  dddd: any={};
  de: any={};
  d: any = {};
  dept: any = {};
  dep: any = {};
  ddd : any = {};
  s: any = {};
  sss: any = {};
  Division_Id : any;
  Dept_Id : any;
  mode : string;
  Districtlist: any={};
  DeptmastList : any={};
  Divisdepartlist: any=[];
  SectionmastList: any=[];
  Deptlist: any=[];
  DivisionmastList: any=[];
  Statelist: any={};
  divi : any={};
  dd: any={};
  today: any;
  divisionMast:string;
  Deprt_Code: any;
  Division_Codes: any;
  Division_Ids: any;
  Dept_Ids: any;

  dtOptions: any = {};
  CompanyList: any[] = [];

  DOC_NOs: any;
  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;
  isSearch: boolean;
  dtTrigger: Subject<any> = new Subject();                           
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;




  constructor(private UserService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,
    ) 
{ }


  ngOnInit(): void {

    this.GetSectionDetails();
    this.GetDepartmentDetaisl();  
   this.GetDivisionDetaisl();

   this.GetAllData(); 
   this.GetAllDivisioname();
   this. GetAlldepart();
    this.today = new Date().toISOString().split('T')[0];
  


    this.dtOptions = {
      dom: 'lBfrtip',
      lengthMenu: [[5, 10, 20, -1], [5, 10, 20, "All"]],
      scroll: "250px",
      select: true,
      buttons: [
        {
          extend: 'collection',
          text: 'Export',
          buttons: ['copy', 'csv', 'excel', 'pdf', 'print',]
        },
        { extend: 'colvis', text: 'Column Visibility', classname: 'btn btn-primary' }
      ],
    }
  }





  GetAllData() {
  
    
    this.data = this.UserService.GetAllDistricts();
    this.data.subscribe(
      (response: any) => {
        this.Districtlist = response.Result;
        console.log("district");
        console.log(this.Districtlist)
      })

      

       
  

      this.data = this.UserService.GetAllStatelist();
    this.data.subscribe(
      (response: any) => {
        this.Statelist = response.Result;
      })
  }

  GetAlldepart(){
  this.data = this.UserService.GetAlldepart();
  this.data.subscribe(
    (response: any) => {
      this.Deptlist = response.Result;
      console.log("Deptlist");
      console.log(this.Deptlist)
    })
  }
  GetAllDivisioname(){
    this.data = this.UserService.GetAllDivisioname();
    this.data.subscribe(
      (response: any) => {
        this.Divisdepartlist = response.Result;
        console.log("Divisdepartlist");
        console.log(this.Divisdepartlist)
      })
    }

  //get division details for inner grid
GetDivisionDetaisl()
{  
  this.data = this.UserService.GetAllDivisionDetailsInnerGrid();
  this.data.subscribe(
    (response: any) => {
      this.DivisionmastList =response;
    
      this.rerender(); 
      console.log('DivisionmastList Deatils');
      console.log(response); 
       

      
    })
  }




  GetDepartmentDetaisl()
  {  
    this.data = this.UserService.GetAlldepartmentGrid();
    this.data.subscribe(
      (response: any) => {
        this.DeptmastList =response;
      
        
  
        console.log('DivisionmastListDeatils');
        console.log(response); 
         
  
        
      })
    }
  //  GetSectionDetails

  GetSectionDetails()
  {  
    this.data = this.UserService.GetSectionDetails();
    this.data.subscribe(
      (response: any) => {
        this.SectionmastList =response;
      
        
  
        console.log('DivisionmastListDeatils');
        console.log(response); 
         
  
        
      })
    }

//radio buttons
removedetails(){
  
  this.c.Company_Name='';
this.c.Company_Adress='';
this.c.Adress1='';
this.c.District_Code='';
this.c.State_Code='';
this.c.Pin_Code='';
this.c.Telephone_No='';
this.c.Alt_Telephone_No='';
this.c.Fax_No='';
this.c.Email='';
this.c.Cin_No='';
this.c.Company_Reg_No='';
this.c.Tin_Gst_No='';
this.c.Company_Pan_No='';
this.c.Company_Website='';
  
}

GetCompnydetails() {
  //debugger;

  this.data = this.UserService.GetCompanyDetailsfor();
  this.data.subscribe(
    (response: any) => {  
      // this.c.Company_Name = response.Company_Name
      this.c=response;
      this.c.Company_Dtl_Radio='Y';
      
     this.GetAllData();

     console.log("companydetails");
     console.log(this.data);
    })
} 


  SaveDivisionMaster(DivisionMaster: NgForm){ 
    debugger;
    
    if(DivisionMaster.invalid)
    {
      this.formInvalid = true;
      swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
      return;
    }     

    else{                                     
            this.data = this.UserService.PostDivision(DivisionMaster.value);    
            this.data.subscribe(
            (response) => {
              DivisionMaster.reset();
              DivisionMaster.resetForm();
              DivisionMaster.form.markAsPristine();
              DivisionMaster.form.markAsUntouched();        
           
              this.GetDivisionDetaisl();
              this.GetAllDivisioname();
              swal('Success!', 'Division and Department Added Successfully .', 'success');
             // this.router.navigate(['/home/division/division-form']) ;   
              document.getElementById('loader-spinner').style.display = "none";           
            }, (error) => {
              document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401|| error.status == 500) {
                this.errorHandler.handleError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
            });    
    
    
    } 
  }

  GetByIdDivision(Division_Id,mode){
    this.Division_Ids=Division_Id;
    this.mode=mode
    document.getElementById('loader-spinner').style.display = "block";
        this.data = this.UserService.GetByIdDivision(Division_Id);
        this.data.subscribe(
          (response: any) => {
            this.c = response;        
                          
            document.getElementById('loader-spinner').style.display = "none";
          },(error) => {
            document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401 || error.status == 500) {
              this.errorHandler.handleError(error);
            }
            else if (error.status == 400) {
              swal('Warning!', error.error.Message, 'warning');
            }
          });

          
  }


  UpdateDivisionMaster(DivisionMaster: NgForm) {  
    this.data = this.UserService.UpdateDivision(DivisionMaster.value, this.Division_Ids);
   this.data.subscribe(
     (response) => {
     DivisionMaster.reset();
      DivisionMaster.resetForm();
      DivisionMaster.form.markAsPristine();
      DivisionMaster.form.markAsUntouched(); 
      this.mode=null;
      // form.resetForm();
     // this.router.navigate(['/home/division/division-form']) Edit;   
       swal('Success!', 'Division Department updated Successfully .', 'success');
       this.GetDivisionDetaisl();     
       document.getElementById('loader-spinner').style.display = "none";   
       this.router.navigate(['/home/division']) ;          
     }, (error) => {
       document.getElementById('loader-spinner').style.display = "none";
       if (error.status == 401|| error.status == 500) {
         this.errorHandler.handleError(error);
       }
       else if (error.status == 400) {
         swal('Warning!', error.error.Message, 'warning');
       }
     });   
    // this.router.navigate(['/home/division/division-form']) ;  
  
    this.GetDivisionDetaisl();   
   
}

Cancel(){
//this.router.navigate(['/home/district']) ; 
this.c.Division_Name='';
this.c.Company_Name='';
this.c.Company_Adress='';
this.c.Adress1='';
this.c.District_Code='';
this.c.State_Code='';
this.c.Pin_Code='';
this.c.Telephone_No='';
this.c.Alt_Telephone_No='';
this.c.Fax_No='';
this.c.Email='';
this.c.Cin_No='';
this.c.Company_Reg_No='';
this.c.Tin_Gst_No='';
this.c.Company_Pan_No='';
this.c.Company_Website='';
}


delete(Division_Id){
  swal({
     title: 'Are you sure?', text: "It will Delete Related Department and Section Details !!You want to delete!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
   }).then((result) => {
      if (result.value) {
      this.data = this.UserService.DeleteDivisionDetails(Division_Id);
      this.data.subscribe(
       (response: any) => {
        this.GetDivisionDetaisl();
            
       }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401|| error.status == 500) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      }    
    ); 
  } 
  })
  }

 //DEPARTEMent

 SaveDepartmentMaster(DepartmentMaster: NgForm){ 
  //  debugger;
    if(DepartmentMaster.invalid)
    {
      this.formInvalid = true;
      swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
      return;
    }     

    else{                                     
            this.data = this.UserService.PostDept(DepartmentMaster.value);    
            this.data.subscribe(
            (response) => {
              DepartmentMaster.reset();
              DepartmentMaster.resetForm();
              DepartmentMaster.form.markAsPristine();
              DepartmentMaster.form.markAsUntouched();        
              swal('Success!', 'Department Added Successfully .', 'success');
              this.GetDepartmentDetaisl();  
              this. GetAlldepart();
              this.router.navigate(['/home/division/division-form']) ;   
              document.getElementById('loader-spinner').style.display = "none";           
            }, (error) => {
              document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401|| error.status == 500) {
                this.errorHandler.handleError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
            });    
    
        
    } 
  }

  GetDepartmentMasterById(Dept_Id,mode){
    this.mode=mode
    this.Dept_Ids=Dept_Id
    document.getElementById('loader-spinner').style.display = "block";
        this.data = this.UserService.GetByIdDept(Dept_Id);
        this.data.subscribe(
          (response: any) => {
            this.de = response;  
            console.log(response);      
                          
            document.getElementById('loader-spinner').style.display = "none";
          },(error) => {
            document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401 || error.status == 500) {
              this.errorHandler.handleError(error);
            }
            else if (error.status == 400) {
              swal('Warning!', error.error.Message, 'warning');
            }
          });
  }


  UpdateDepartmentMaster(DepartmentMaster: NgForm) {  
    this.data = this.UserService.UpdateDept(DepartmentMaster.value,this.Dept_Ids);
   this.data.subscribe(
     (response) => {
      DepartmentMaster.reset();
      DepartmentMaster.resetForm();
      DepartmentMaster.form.markAsPristine();
      DepartmentMaster.form.markAsUntouched(); 
      this.mode=null;          
      this.router.navigate(['/home/division/division-form']) ;   
       swal('Success!', 'Department updated Successfully .', 'success');
       this.GetDepartmentDetaisl();  
       document.getElementById('loader-spinner').style.display = "none";   
       this.router.navigate(['/home/division/division-form']) ;          
     }, (error) => {
       document.getElementById('loader-spinner').style.display = "none";
       if (error.status == 401|| error.status == 500) {
         this.errorHandler.handleError(error);
       }
       else if (error.status == 400) {
         swal('Warning!', error.error.Message, 'warning');
       }
     });   

  this.GetDepartmentDetaisl();
  this.GetAlldepart();  
  this.router.navigate(['/home/division/division-form']) ;     

}

//section





//DEPARTEMent

Savesection(section: NgForm){ 
 
  //debugger;
  if(section.invalid)
  {
    this.formInvalid = true;
    swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
    return;
  }     

  else{                                     
          this.data = this.UserService.PostSection(section.value);    
          this.data.subscribe(
          (response) => {
            section.reset();
            section.resetForm();
            section.form.markAsPristine();
            section.form.markAsUntouched();        
            swal('Success!', 'Section Added Successfully .', 'success');
            this.GetSectionDetails();
            // this.router.navigate(['/home/division/division-form']) ;   
            document.getElementById('loader-spinner').style.display = "none";           
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401|| error.status == 500) {
              this.errorHandler.handleError(error);
            }
            else if (error.status == 400) {
              swal('Warning!', error.error.Message, 'warning');
            }
          });    
  
      
  } 
}

GetsectionById(Dept_Id,mode){
  debugger;
  this.mode=mode
  this.Dept_Ids=Dept_Id
  document.getElementById('loader-spinner').style.display = "block";
      this.data = this.UserService.GetByIdSection( this.Dept_Ids);
      this.data.subscribe(
        (response: any) => {
          this.s = response;  
          console.log(response);      
                        
          document.getElementById('loader-spinner').style.display = "none";
        },(error) => {
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401 || error.status == 500) {
            this.errorHandler.handleError(error);
          }
          else if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        });
}


UpdateSection(section: NgForm) {  
  this.data = this.UserService.UpdateSection(section.value,this.Dept_Ids);
 this.data.subscribe(
   (response) => {
    section.reset();
    section.resetForm();
    section.form.markAsPristine();
    section.form.markAsUntouched();           
    this.mode=null;
     swal('Success!', 'Section updated Successfully .', 'success');
     this.GetDepartmentDetaisl();  
     this.GetSectionDetails();
     document.getElementById('loader-spinner').style.display = "none";   
     this.router.navigate(['/home/division/division-form']) ;          
   }, (error) => {
     document.getElementById('loader-spinner').style.display = "none";
     if (error.status == 401|| error.status == 500) {
       this.errorHandler.handleError(error);
     }
     else if (error.status == 400) {
       swal('Warning!', error.error.Message, 'warning');
     }
   });   

   this.GetSectionDetails();
   this.router.navigate(['/home/division/division-form']) ;     
}

//save for section
save(Dept_name,Dept_Id){ 


  this.data = this.UserService.UpdateSections(Dept_name,Dept_Id);
  this.data.subscribe(
    (response: any) => {  
      swal('Success!', 'Section is Added successfully', 'success');
     // this.GetDepartmentDetaisl();
     this.s = {};
     this.router.navigate(['/home/division/division-form']) ;   
      this.GetSectionDetails();
    //  this.GetAllComapliantSanDetails(this.itemsPerPage, this.currentPage);
      document.getElementById('loader-spinner').style.display = "none";
    },
    (error) => {
      document.getElementById('loader-spinner').style.display = "none";
    }
  );
}




Updatesections(section: NgForm) {  
  this.data = this.UserService.UpdateSection(section.value,this.Deprt_Code);
 this.data.subscribe(
   (response) => {
    section.reset();
    section.resetForm();
    section.form.markAsPristine();
    section.form.markAsUntouched();   
    this.mode=null;        
    this.router.navigate(['/home/division/division-form']) ;    
     swal('Success!', 'Section updated Successfully .', 'success');
     this.GetDepartmentDetaisl();  
     document.getElementById('loader-spinner').style.display = "none";   
     this.router.navigate(['/home/division/division-form']) ;          
   }, (error) => {
     document.getElementById('loader-spinner').style.display = "none";
     if (error.status == 401|| error.status == 500) {
       this.errorHandler.handleError(error);
     }
     else if (error.status == 400) {
       swal('Warning!', error.error.Message, 'warning');
     }
   });   

   this.GetSectionDetails();
   this.router.navigate(['/home/division/division-form']) ;     
}  


//delete for section and department
delete1(Deprt_Code){
  swal({
     title: 'Are you sure?', text: "You have to Delete releated Section details in this particular Department!" ,  
     type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
   }).then((result) => {
      if (result.value) {
      this.data = this.UserService.DeleteDeptails(Deprt_Code);
      this.data.subscribe(
       (response: any) => {
        this.GetDepartmentDetaisl();  
                 
       }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401|| error.status == 500) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      }    
    ); 
  } 
  })
  }
//delete for section and department
delete2(Deprt_Code){
  swal({
     title: 'Are you sure?', text: "You want to delete!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
   }).then((result) => {
      if (result.value) {
      this.data = this.UserService.DeleteSectails(Deprt_Code);
      this.data.subscribe(
       (response: any) => {
        this.GetSectionDetails();
            
       }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401|| error.status == 500) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      }    
    ); 
  } 
  })
  }

 
//dlete dividon for child details
GetDivisionForDelete(Division_Ids){
  debugger;
  //this.Division_Ids=this.Division_Id;


  this.data = this.UserService.GetAlldivisionForDelete(Division_Ids);
  this.data.subscribe(
    (response: any) => {
      this.divi = response.Result;
      var div=this.Deptlist.length;
      if (div==0)
      {       
            this.data = this.UserService.DeleteDivisionDetails(Division_Ids);
            this.data.subscribe(
             (response: any) => {
              this.GetDivisionDetaisl();
                       
             }, (error) => {
              document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401|| error.status == 500) {
                this.errorHandler.handleError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
            }    
          ); 
        }
        
        else{
          
          swal('Warning!', 'You have to Delete releated Department And Section details in this particular Division.', 'warning');
          return
        }

        })
        }
      
        GetdepartmentForDelete(Dept_Id){
        //  this.ddd.DivisionDept_Code=this.Division_Code;
      

          this.data = this.UserService.GetAlldeprtForDelete(Dept_Id);
          this.data.subscribe(
            (response: any) => {
              this.sss = response.Result;
              var sss=this.sss.length;
              if (sss==0)
              {       
                    this.data = this.UserService.DeleteDeptails(Dept_Id);
                    this.data.subscribe(
                     (response: any) => {
                      this.GetDepartmentDetaisl();  
                                
                     }, (error) => {
                      document.getElementById('loader-spinner').style.display = "none";
                      if (error.status == 401|| error.status == 500) {
                        this.errorHandler.handleError(error);
                      }
                      else if (error.status == 400) {
                        swal('Warning!', error.error.Message, 'warning');
                      }
                    }    
                  ); 
                }
                
                else{
                  
                  {
                  swal('Warning!', 'You have to Delete releated Section details in this particular Department.', 'warning');
                  }
                  return
                }
        
                })
                }
              

    
  
         /*for Datatable*/
         ngAfterViewInit(): void {
          this.dtTrigger.next();
        }
      
      
        ngOnDestroy(): void { 
          this.dtTrigger.unsubscribe();
        }
      
        rerender(): void {
          try {
            this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
              dtInstance.destroy();
            });
           this.dtTrigger.next();
          } catch (err) {
            console.log(err);
          }
        }
}







// WEBPACK FOOTER //
// ./src/app/ultilities/division-department/division-dept-grid/division-dept-grid.component.ts